




















// 3rd party libs
import Vue from 'vue';

// Components
import listEmpty from '@webapp/components/nft/list-empty.vue';
import nftCardTile from '@webapp/components/nft/card.vue';

export default Vue.extend({
    name: 'nft-list',
    components: {
        listEmpty,
        nftCardTile,
    },
    props: {
        nfts: {
            type: Array,
            required: true,
        },
    },
    computed: {
        hasNfts(): boolean {
            return Boolean(this.nfts.length);
        },
    },
});
